module.exports = __webpack_public_path__ + "img/Jump Casting85.695e8f5a.jpg";